<template>
  <el-dialog
    title="单位编辑"
    :visible.sync="state"
    width="30%"
    :before-close="handleClose"
  >
    <!-- 内容 -->
    <tz-form
      width="110px"
      :formConfig="formConfig"
      :formBtns="formBtns"
      :row="user"
      @submit="submitFn"
    ></tz-form>
    <!-- 内容 -->
  </el-dialog>
</template>

<script>
export default {
  props: {
    state: {
      type: Boolean,
      default: false
    },
    user: Object,
    roles: Array
  },

  data() {
    return {
      // 表单配置
      formConfig: [
        {
          label: '单位名称',
          field: 'unitName',
          type: 'text',
          rules: [
            { required: true, message: '单位名称必填', trigger: 'blur' }
            // { min: 3, max: 20, message: '长度为3到20', trigger: 'blur' },
            // {
            //   validator: this.checkLoginName,
            //   trigger: 'blur'
            // }
          ]
        },
        {
          label: '单位中文简写',
          field: 'shortCn',
          type: 'text',
          rules: [
            { required: true, message: '单位简写必填', trigger: 'blur' }
            // { min: 1, max: 5, message: '简写长度为1到5', trigger: 'blur' }
          ]
        },
        {
          label: '单位英文简写',
          field: 'shortEn',
          type: 'text',
          rules: [
            // { required: true, message: '单位中文简写必填', trigger: 'blur' },
            // { min: 1, max: 5, message: '简写长度为1到5', trigger: 'blur' }
          ]
        }
        // {
        //   label: '用户姓名',
        //   field: 'userName',
        //   type: 'text',
        //   rules: [
        //     { required: true, message: '用户姓名必填', trigger: 'blur' },
        //     { min: 2, max: 20, message: '长度为2到20', trigger: 'blur' }
        //   ]
        // },
        // {
        //   label: '角色',
        //   field: 'roleId',
        //   type: 'select',
        //   payload: this.roles,
        //   rules: [{ required: true, message: '角色必选', trigger: 'blur' }]
        // }
      ],

      formBtns: [
        {
          content: '更新',
          width: '185px',
          type: 'primary'
          // },
          // {
          //   content: '重置',
          //   type: ''
        }
      ]
    }
  },
  methods: {
    handleClose() {
      this.$emit('close')
    },
    submitFn(formData) {
      this.$emit('confirm', formData)
      console.log('更新数据处理', formData)
    }
  }
}
</script>

<style></style>
